




import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';

@Component({
  components: {
  },
})
export default class Loading extends Vue {
  @Prop({ required: false, type: String, default: '150px' })
  public size!: string;
}
